import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { ThemeService } from './services/theme.service';

@Directive({
  selector: '[appInitTheme]'
})
export class InitThemeDirective implements OnInit {

  private oldTheme = '';

  constructor(private render: Renderer2, private elemenRef: ElementRef, private themeService: ThemeService) { }

  ngOnInit() {
    this.themeService.getTheme()
    .subscribe(theme => {
      if (this.oldTheme) {
        this.render.removeClass(this.elemenRef.nativeElement, this.oldTheme);
      }
      this.render.addClass(this.elemenRef.nativeElement, theme);
      this.oldTheme = theme;
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/init-theme.directive.ts